import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent, useRef } from "react";
import { Collapse, Button, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledTooltip
} from "reactstrap";

type State = {            
}

type Props = {    
    text: string,
    disabled: boolean,
    onClick: () => void,
    expanded: boolean,
    className: string;
}

export class CollapseControl extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        
    }
    
    static defaultProps = {
        text:"",
        className: "",
        disabled: false
    }

    state: State = {
        
         
    }

    

    render() {  
        return <div>
                <button className={"kslplus-collaps-button" + (this.props.expanded ? " expanded" : "")} disabled={this.props.disabled} onClick={() => this.props.onClick()}>
                    <div >{this.props.text}</div>
                    <div className="rotate90">
                        <svg
                            className={"kslplus-collaps-button-icon" + (this.props.expanded ? " expanded" : "")}
                            viewBox="6 0 12 24"
                        >
                            <polygon points="8 0 6 1.8 14.4 12 6 22.2 8 24 18 12" />
                        </svg>
                    </div>
                </button>
                <Collapse isOpen={this.props.expanded} className={"kslplus-collapse-gradient " + (this.props.expanded ? " expanded " : " ") + this.props.className}>
                    {this.props.children }
                </Collapse>
            </div>;
    }
}
